import { render, staticRenderFns } from "./newsInfoBox.vue?vue&type=template&id=e560ef80&"
import script from "./newsInfoBox.vue?vue&type=script&lang=ts&"
export * from "./newsInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports